/* eslint-disable */
if (process.env.NODE_ENV === 'test') {
  require = require('src/utils/jestWebpackPolyfill').default;
}
/* eslint-enable */

const mdlRequire = require.context('.', false, /^\.\/(?!.*\.spec\.js$).*\.js$/);
const regName = /^\.\/(.*)\.js$/;
const modules = {};

mdlRequire.keys().map((path) => {
  const filter = mdlRequire(path).default;
  const name = path.replace(regName, '$1');
  modules[name] = filter;
  return modules;
});

delete modules.index;
export default modules;
